import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, KeyValuePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from '@app/modules/alerts/alert.module';
import { InputsModule } from '@app/modules/inputs';
import { PipesModule } from '@app/modules/pipes/pipes.module';
import { AdvancedQueryComponent } from '@app/modules/query/components/advanced-query/advanced-query.component';
import { BasicQueryChipComponent } from '@app/modules/query/components/basic-query-chips/basic-query-chip/basic-query-chip.component';
import { BasicQueryChipsComponent } from '@app/modules/query/components/basic-query-chips/basic-query-chips.component';
import { BasicQueryInnerComponent } from '@app/modules/query/components/basic-query/basic-query-inner/basic-query-inner.component';
import { BasicQueryRowComponent } from '@app/modules/query/components/basic-query/basic-query-row/basic-query-row.component';
import { BasicQueryComponent } from '@app/modules/query/components/basic-query/basic-query.component';
import { BasicSearchComponent } from '@app/modules/query/components/basic-search/basic-search.component';
import { BasicTransformerFieldComponent } from '@app/modules/query/components/basic-transformer-field/basic-transformer-field.component';
import { BasicTransformerComponent } from '@app/modules/query/components/basic-transformer/basic-transformer.component';
import { QueryButtonsComponent } from '@app/modules/query/components/query-buttons/query-buttons.component';
import { QueryInputsComponent } from '@app/modules/query/components/query-inputs/query-inputs.component';
import { QuerySearchComponent } from '@app/modules/query/components/query-search/query-search.component';
import { QueryTypeButtonsComponent } from '@app/modules/query/components/query-type-buttons/query-type-buttons.component';
import { TransformerInputsComponent } from '@app/modules/query/components/transformer-inputs/transformer-inputs.component';
import { SearchBarModule } from '@app/modules/search-bar/search-bar.module';
import { ClearableChipComponent } from '@app/standalone-components/chips/clearable-chips/clearable-chip.component';
import { SpinnerComponent } from '@app/standalone-components/spinner/spinner.component';
import { SelectModule } from '@feedonomics/frontend-components';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbCollapseModule, NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    declarations: [
        AdvancedQueryComponent,
        BasicQueryChipComponent,
        BasicQueryChipsComponent,
        BasicQueryComponent,
        BasicQueryInnerComponent,
        BasicQueryRowComponent,
        BasicSearchComponent,
        BasicTransformerComponent,
        BasicTransformerFieldComponent,
        QueryButtonsComponent,
        QueryInputsComponent,
        QuerySearchComponent,
        QueryTypeButtonsComponent,
        TransformerInputsComponent
    ],
    imports: [
        AlertModule,
        ClearableChipComponent,
        CommonModule,
        DragDropModule,
        FontAwesomeModule,
        InputsModule,
        NgbCollapseModule,
        NgbDropdownModule,
        NgbTooltipModule,
        NgSelectModule,
        PipesModule,
        ReactiveFormsModule,
        SearchBarModule,
        SelectModule,
        SpinnerComponent
    ],
    exports: [
        AdvancedQueryComponent,
        BasicTransformerComponent,
        BasicTransformerFieldComponent,
        QueryButtonsComponent,
        QueryInputsComponent,
        QuerySearchComponent,
        QueryTypeButtonsComponent,
        TransformerInputsComponent
    ],
    providers: [
        KeyValuePipe
    ]
})
export class QueryModule { }
